import React, { useState } from 'react';
import { Film, Eye, EyeOff } from 'lucide-react';

export default function LoginPage({ onLogin }) {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState('');
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onLogin(user, pass)) {
      setError('');
    } else {
      setError('Usuario o contraseña incorrectos');
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setPass('');
    }
  };

  return (
    <div className="min-h-screen bg-cinema-bg flex items-center justify-center p-4">
      {/* Background effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cinema-accent/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" />
      </div>

      <div className={`relative bg-cinema-card border border-cinema-border rounded-2xl shadow-2xl w-full max-w-sm p-8 animate-fade-in ${shake ? 'animate-[shake_0.5s_ease-in-out]' : ''}`}>
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-cinema-accent/10 rounded-2xl mb-4">
            <Film size={32} className="text-cinema-accent" />
          </div>
          <h1 className="text-2xl font-bold text-white">My Cinema</h1>
          <p className="text-steel-300 text-sm mt-1">Tu gestor personal</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-steel-300 mb-1.5">Usuario</label>
            <input
              type="text"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              className="w-full bg-cinema-bg border border-cinema-border rounded-xl px-4 py-3 text-white placeholder-steel-400 focus:outline-none focus:border-cinema-accent focus:ring-1 focus:ring-cinema-accent/30 transition-all"
              placeholder="Tu usuario"
              autoFocus
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-steel-300 mb-1.5">Contraseña</label>
            <div className="relative">
              <input
                type={showPass ? 'text' : 'password'}
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                className="w-full bg-cinema-bg border border-cinema-border rounded-xl px-4 py-3 pr-12 text-white placeholder-steel-400 focus:outline-none focus:border-cinema-accent focus:ring-1 focus:ring-cinema-accent/30 transition-all"
                placeholder="Tu contraseña"
                required
              />
              <button
                type="button"
                onClick={() => setShowPass(!showPass)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-steel-400 hover:text-steel-200 transition-colors"
              >
                {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          {error && (
            <p className="text-red-400 text-sm text-center bg-red-900/20 rounded-lg py-2">{error}</p>
          )}

          <button
            type="submit"
            className="w-full bg-cinema-accent hover:bg-cinema-accent-hover text-white font-semibold py-3 px-4 rounded-xl transition-all duration-200 shadow-lg shadow-cinema-accent/20 hover:shadow-cinema-accent/30"
          >
            Acceder
          </button>
        </form>
      </div>
    </div>
  );
}
